import { Dispensary, DispensaryTagsEnum } from "custom-types/Dispensary";

const isDispensaryDualLicense = (tags: Dispensary["tags"]) =>
  tags?.includes(DispensaryTagsEnum.DualLicense);

export default isDispensaryDualLicense;
